var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "147px",
    height: "104px",
    viewBox: "0 0 147 104",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "1A54894A-956E-444F-A143-A8A0D4DC2784") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 147,
    height: 104,
    rx: 8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "path-3",
    cx: 3,
    cy: 3,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    id: "path-5",
    cx: 3,
    cy: 3,
    r: 3
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "KIT",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Elementler-KIT",
    transform: "translate(-1022.000000, -1810.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Chat",
    transform: "translate(1022.000000, 1810.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#FAFAFC",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-49",
    mask: "url(#mask-2)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(29.000000, 17.000000)",
    id: "Rectangle-Copy-63"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 90,
    height: 70
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group-45",
    mask: "url(#mask-2)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(40.000000, 35.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10,0 L66,0 C67.1045695,-2.02906125e-16 68,0.8954305 68,2 L68,10 C68,11.1045695 67.1045695,12 66,12 L8,12 L8,12 L8,2 C8,0.8954305 8.8954305,2.02906125e-16 10,0 Z",
    id: "Rectangle",
    fill: "#F9F9F9",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42,15 L58,15 C59.1045695,15 60,15.8954305 60,17 L60,21 C60,22.1045695 59.1045695,23 58,23 L40,23 L40,23 L40,17 C40,15.8954305 40.8954305,15 42,15 Z",
    id: "Rectangle-Copy-133",
    fill: "#EDEDED",
    fillRule: "evenodd",
    transform: "translate(50.000000, 19.000000) scale(-1, 1) translate(-50.000000, -19.000000) "
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-134",
    fill: "#F9F9F9",
    fillRule: "evenodd",
    transform: "translate(31.000000, 30.000000) scale(-1, 1) translate(-31.000000, -30.000000) ",
    x: 0,
    y: 26,
    width: 62,
    height: 8,
    rx: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.0031454,31.8144275 L64.341127,30.351323 C64.3544684,30.2890632 64.4078339,30.2401448 64.4745408,30.2312506 L66.3645694,30.035577 C66.4179349,30.0311299 66.4179349,29.9510816 66.3645694,29.9421874 L64.4745408,29.7598552 C64.4078339,29.7554081 64.3544684,29.7064897 64.341127,29.6442299 L64.0031454,28.1855725 C63.9720155,28.061053 64.1054293,27.9587691 64.2210546,28.0165817 L67.9166164,29.8665862 C68.0277945,29.9243989 68.0277945,30.0844954 67.9166164,30.142308 L64.2210546,31.9834183 C64.1054293,32.0412309 63.9720155,31.938947 64.0031454,31.8144275 Z",
    id: "Path",
    fill: "#6F6F6F",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Shape",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(0.000000, 1.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#979797",
    xlinkHref: "#path-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.9936156,3.92464142 L2.9936156,3.92592593 C2.9958661,3.92592593 2.99782302,3.92528366 2.99997558,3.92528366 C3.00212813,3.92528366 3.004183,3.92592593 3.00633556,3.92592593 L3.00633556,3.92464142 C3.67887937,3.9175765 4.22222222,3.36601468 4.22222222,2.68515989 C4.22222222,2.00435569 3.67877917,1.452837 3.00633556,1.44572895 L3.00633556,1.44444444 C3.004183,1.44444444 3.00212813,1.44508672 2.99997558,1.44508672 C2.99787187,1.44508672 2.99581713,1.44444444 2.99366444,1.44444444 L2.99366444,1.44572895 C2.32112063,1.45279387 1.77777778,2.00435569 1.77777778,2.68515989 C1.77777778,3.36601468 2.32107054,3.91757131 2.99361435,3.92464142 L2.9936156,3.92464142 Z M3.09390619,4.11111111 L2.90624461,4.11111111 C1.79296684,4.11684752 0.888888889,4.97229384 0.888888889,6.02378576 C0.888888889,6.11299164 0.960015317,6.18518519 1.04792498,6.18518519 L4.95207502,6.18518519 C5.03998845,6.18518519 5.11111111,6.11304267 5.11111111,6.02378576 C5.11111111,4.97233117 4.20709599,4.11683582 3.09388105,4.11111111 L3.09390619,4.11111111 Z M2.98148148,1.44444444 C2.29623702,1.44444444 1.74074074,1.99999132 1.74074074,2.68518519 C1.74074074,3.37042965 2.29628761,3.92592593 2.98148148,3.92592593 C3.66672594,3.92592593 4.22222222,3.37037905 4.22222222,2.68518519 C4.22232103,1.99999132 3.66677654,1.44444444 2.98148148,1.44444444 Z",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    mask: "url(#mask-4)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Shape-Copy-14",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(62.000000, 17.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-6",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-5"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#979797",
    xlinkHref: "#path-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.9936156,3.92464142 L2.9936156,3.92592593 C2.9958661,3.92592593 2.99782302,3.92528366 2.99997558,3.92528366 C3.00212813,3.92528366 3.004183,3.92592593 3.00633556,3.92592593 L3.00633556,3.92464142 C3.67887937,3.9175765 4.22222222,3.36601468 4.22222222,2.68515989 C4.22222222,2.00435569 3.67877917,1.452837 3.00633556,1.44572895 L3.00633556,1.44444444 C3.004183,1.44444444 3.00212813,1.44508672 2.99997558,1.44508672 C2.99787187,1.44508672 2.99581713,1.44444444 2.99366444,1.44444444 L2.99366444,1.44572895 C2.32112063,1.45279387 1.77777778,2.00435569 1.77777778,2.68515989 C1.77777778,3.36601468 2.32107054,3.91757131 2.99361435,3.92464142 L2.9936156,3.92464142 Z M3.09390619,4.11111111 L2.90624461,4.11111111 C1.79296684,4.11684752 0.888888889,4.97229384 0.888888889,6.02378576 C0.888888889,6.11299164 0.960015317,6.18518519 1.04792498,6.18518519 L4.95207502,6.18518519 C5.03998845,6.18518519 5.11111111,6.11304267 5.11111111,6.02378576 C5.11111111,4.97233117 4.20709599,4.11683582 3.09388105,4.11111111 L3.09390619,4.11111111 Z M2.98148148,1.44444444 C2.29623702,1.44444444 1.74074074,1.99999132 1.74074074,2.68518519 C1.74074074,3.37042965 2.29628761,3.92592593 2.98148148,3.92592593 C3.66672594,3.92592593 4.22222222,3.37037905 4.22222222,2.68518519 C4.22232103,1.99999132 3.66677654,1.44444444 2.98148148,1.44444444 Z",
    id: "Shape",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    mask: "url(#mask-6)"
  })), /*#__PURE__*/React.createElement("text", {
    id: "Let\\u2019s-go-to-the-part",
    fill: "none",
    fontFamily: "OpenSans, Open Sans",
    fontSize: 3,
    fontWeight: "normal"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 10,
    y: 5,
    fill: "#464646"
  }, "Let\u2019s go to the party!")), /*#__PURE__*/React.createElement("text", {
    id: "Let\\u2019s-go!",
    fill: "none",
    fontFamily: "OpenSans, Open Sans",
    fontSize: 3,
    fontWeight: "normal"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 45,
    y: 20,
    fill: "#464646"
  }, "Let\u2019s go!")), /*#__PURE__*/React.createElement("text", {
    id: "Type-a-message",
    fill: "none",
    fontFamily: "OpenSans, Open Sans",
    fontSize: 3,
    fontWeight: "normal"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 4,
    y: 31,
    fill: "#BBBBBD"
  }, "Type a message")))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChat);
export default __webpack_public_path__ + "static/media/Chat.2e020706fce17b68870c9318240a1803.svg";
export { ForwardRef as ReactComponent };